import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Page } from "~/components/ui/page";
import { ErrorState, Skeleton } from "~/components/ui/states";
import { PurchaseOrderView } from "~/features/purchasing/detail";
import { fetchPurchaseOrder, PurchasingBackLink } from "~/features/purchasing/model";

export const Route = createFileRoute("/_app/purchasing/$id")({ component: PurchaseOrderPage });

function PurchaseOrderPage() {
  const { id } = Route.useParams();
  const query = useQuery({ queryKey: ["purchasing", id], queryFn: () => fetchPurchaseOrder(id) });
  if (query.isPending)
    return (
      <Page>
        <PurchasingBackLink />
        <Skeleton className="h-8 w-60" />
        <Skeleton className="mt-6 h-96 w-full" />
      </Page>
    );
  if (query.isError)
    return (
      <Page>
        <PurchasingBackLink />
        <ErrorState error={query.error} onRetry={() => void query.refetch()} />
      </Page>
    );
  return <PurchaseOrderView key={`${query.data.id}-${query.data.updatedAt}`} order={query.data} />;
}
